import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getAllDivisionsByEstateID,
    getAllCollectionTypesByoperationEntityID,
    getEmployeeImageReportSundryData,
    getAllNarrationsForDropDown,
    getCollectionPointByOperationEntityId
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getAllNarrationsForDropDown() {
    var narrationArray = [];
    const response = await CommonGet('/api/EmployeeSessionImageReport/GetAllNarations', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            narrationArray.push(item[1]["narration"]);
        }
    }
    return narrationArray;
}



async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetEstatesByGroupID', 'groupID=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}


async function getAllDivisionsByEstateID(estateID) {
    var routeArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + estateID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            routeArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return routeArray;
}

async function getAllCollectionTypesByoperationEntityID(operationEntityID) {
    var collectionTypeArray = [];
    const response = await CommonGet('/api/CollectionType/GetAllCollectionTypesByOperationEntityID', 'operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            collectionTypeArray[item[1]["collectionTypeMasterID"]] = item[1]["collectionTypeName"]
        }
    }
    return collectionTypeArray;
}


async function getEmployeeImageReportSundryData(data) {
    var model = {
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        narration: parseInt(data.narration),
        date: data.date
    };
    
    const response = await CommonPost('/api/EmployeeImageReportSundry/GetEmployeeImageReportSundry',null,model);
    return response.data;
}

async function getCollectionPointByOperationEntityId(groupID, operationEntityID) {
    var collectionPointArray = [];
    let filterModel = {
        operationEntityID: operationEntityID.toString(),
        groupID: groupID.toString()
    }
    var response = await CommonPost('/api/CollectionPoint/GetCollectionPointByOperationEntityId', null, filterModel);
    
    for (let item of Object.entries(response.data)) {
        const entityData = item[1];

        if (entityData["operationEntityTypeID"] === 1) {
            if (entityData["collectionPointCategoryID"] === 3) {
                collectionPointArray[entityData["collectionPointID"]] = entityData["collectionPointName"];
            }
        } else {
            collectionPointArray[entityData["collectionPointID"]] = entityData["collectionPointName"];
        }
    }
    return collectionPointArray;
}